import React from 'react';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../general-components/icon';

interface BroadcastModalProps {
	broadcastOption: string | number;
	goToSettings: any;
	handleClick: any;
	icon: any;
	text: string;
}

export default function BroadcastModal(props: BroadcastModalProps) {
	const {
		broadcastOption,
		goToSettings,
		handleClick,
		icon,
		text,
	} = props;

	return (
		<div className="broadcasting-start-overlay">
			<div className="broadcasting-start-modal">
				<h4>
					{broadcastOption === 'stream' || Number(broadcastOption) === 0
						? 'Before you begin Streaming…'
						: 'Before you begin Recording…'}
				</h4>
				<p>
					Your Greenroom is configured in a way that will allow off-screen
					presenters’ audio to leak into your live show. Turning on
					“Backstage & Producer Comms” will isolate audio output to your
					in-canvas presenters.
					<a
						href="https://help.brand.live/hc/en-us/articles/360062129473-Backstage-and-Producer-Comms"
						target="_blank"
						rel="noopener noreferrer"
					>
						{' '}
						Learn more in the Help Center
					</a>
				</p>

				<div className="button-container">
					<button
						className="comms padding-button-medium button-background-shading"
						onClick={goToSettings}
					>
						<Icon name={ICONS.SETTINGS} color={COLORS.WHITE} size={18} />
						&nbsp;&nbsp;Backstage & Producer Comms
					</button>
					<button
						className={classNames(
							broadcastOption === 'record' || Number(broadcastOption) === 1
								? 'record' : 'stream',
							'padding-button-medium button-background-shading text-transform-capitalize',
						)}
						onClick={() => handleClick(true)}
					>
						{icon} {text}
					</button>
				</div>
			</div>
		</div>
	);
}
